import { UserRole } from '@/entities/user-role';

import { type Role } from '../../entities/role';
import { type User } from '../../entities/user';

import { MOCK_SITES } from './sites-data';

export interface UsersData {
  users: User[];
  roles: Role[];
}

export function makeUsersData(): UsersData {
  return {
    users: [
      {
        id: '1',
        firstName: 'John',
        lastName: 'Doe',
        email: 'john.doe@example.com',
        active: true,
        lastLogin: new Date('2024-01-21T16:30:15Z'),
        role: { id: '1', name: 'ACCURE Managers' },
      },
      {
        id: '2',
        firstName: 'Jane',
        lastName: 'Smith',
        email: 'jane.smith@example.com',
        active: true,
        lastLogin: new Date('2024-01-20T09:45:22Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '3',
        firstName: 'Bob',
        lastName: 'Johnson',
        email: 'bob.johnson@example.com',
        active: false,
        lastLogin: new Date('2024-01-18T14:15:30Z'),
        role: { id: '3', name: 'Else42' },
      },
      {
        id: '4',
        firstName: 'Alice',
        lastName: 'Williams',
        email: 'alice.williams@example.com',
        active: true,
        lastLogin: new Date('2024-01-22T11:20:45Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '5',
        firstName: 'Charlie',
        lastName: 'Brown',
        email: 'charlie.brown@example.com',
        active: true,
        lastLogin: new Date('2024-01-19T17:55:10Z'),
        role: { id: '1', name: 'ACCURE Managers' },
      },
      {
        id: '6',
        firstName: 'Diana',
        lastName: 'Davis',
        email: 'diana.davis@example.com',
        active: false,
        lastLogin: new Date('2024-01-17T08:30:25Z'),
        role: { id: '3', name: 'Else42' },
      },
      {
        id: '7',
        firstName: 'Edward',
        lastName: 'Miller',
        email: 'edward.miller@example.com',
        active: true,
        lastLogin: new Date('2024-01-23T13:40:18Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '8',
        firstName: 'Fiona',
        lastName: 'Wilson',
        email: 'fiona.wilson@example.com',
        active: true,
        lastLogin: new Date('2024-01-21T10:25:33Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '9',
        firstName: 'George',
        lastName: 'Moore',
        email: 'george.moore@example.com',
        active: false,
        lastLogin: new Date('2024-01-16T15:10:50Z'),
        role: { id: '3', name: 'Else42' },
      },
      {
        id: '10',
        firstName: 'Helen',
        lastName: 'Taylor',
        email: 'helen.taylor@example.com',
        active: true,
        lastLogin: new Date('2024-01-24T12:35:42Z'),
        role: { id: '1', name: 'ACCURE Managers' },
      },
      {
        id: '11',
        firstName: 'Ian',
        lastName: 'Anderson',
        email: 'ian.anderson@example.com',
        active: true,
        lastLogin: new Date('2024-01-22T16:18:27Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '12',
        firstName: 'Julia',
        lastName: 'Thomas',
        email: 'julia.thomas@example.com',
        active: false,
        lastLogin: new Date('2024-01-15T07:45:12Z'),
        role: { id: '3', name: 'Else42' },
      },
      {
        id: '13',
        firstName: 'Kevin',
        lastName: 'Jackson',
        email: 'kevin.jackson@example.com',
        active: true,
        lastLogin: new Date('2024-01-25T14:22:38Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '14',
        firstName: 'Laura',
        lastName: 'White',
        email: 'laura.white@example.com',
        active: true,
        lastLogin: new Date('2024-01-23T09:15:55Z'),
        role: { id: '1', name: 'ACCURE Managers' },
      },
      {
        id: '15',
        firstName: 'Michael',
        lastName: 'Harris',
        email: 'michael.harris@example.com',
        active: false,
        lastLogin: new Date('2024-01-14T18:50:20Z'),
        role: { id: '3', name: 'Else42' },
      },
      {
        id: '16',
        firstName: 'Nancy',
        lastName: 'Martin',
        email: 'nancy.martin@example.com',
        active: true,
        lastLogin: new Date('2024-01-26T11:05:14Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '17',
        firstName: 'Oliver',
        lastName: 'Garcia',
        email: 'oliver.garcia@example.com',
        active: true,
        lastLogin: new Date('2024-01-24T15:30:08Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '18',
        firstName: 'Patricia',
        lastName: 'Rodriguez',
        email: 'patricia.rodriguez@example.com',
        active: false,
        lastLogin: new Date('2024-01-13T12:40:35Z'),
        role: { id: '3', name: 'Else42' },
      },
      {
        id: '19',
        firstName: 'Quincy',
        lastName: 'Lewis',
        email: 'quincy.lewis@example.com',
        active: true,
        lastLogin: new Date('2024-01-27T10:55:44Z'),
        role: { id: '1', name: 'ACCURE Managers' },
      },
      {
        id: '20',
        firstName: 'Rachel',
        lastName: 'Lee',
        email: 'rachel.lee@example.com',
        active: true,
        lastLogin: new Date('2024-01-25T17:12:29Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '21',
        firstName: 'Samuel',
        lastName: 'Walker',
        email: 'samuel.walker@example.com',
        active: false,
        lastLogin: new Date('2024-01-12T06:20:16Z'),
        role: { id: '3', name: 'Else42' },
      },
      {
        id: '22',
        firstName: 'Tina',
        lastName: 'Hall',
        email: 'tina.hall@example.com',
        active: true,
        lastLogin: new Date('2024-01-28T13:25:51Z'),
        role: { id: '2', name: 'ACCURE Staff' },
      },
      {
        id: '23',
        firstName: 'Victor',
        lastName: 'Allen',
        email: 'victor.allen@example.com',
        active: true,
        lastLogin: new Date('2024-01-26T19:40:37Z'),
        role: { id: '1', name: 'ACCURE Managers' },
      },
    ],

    roles: [
      {
        id: '1',
        name: 'ACCURE Managers',
        permission: UserRole.ADMIN,
        sites: null,
        userCount: 5,
      },
      {
        id: '2',
        name: 'ACCURE Staff',
        permission: UserRole.CUSTOMER,
        sites: [MOCK_SITES[0], MOCK_SITES[1], MOCK_SITES[2]],
        userCount: 11,
      },
      {
        id: '3',
        name: 'Else42',
        permission: UserRole.THIRD_PARTY,
        sites: [MOCK_SITES[0], MOCK_SITES[1]],
        userCount: 7,
      },
    ],
  };
}
